var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 26,
    viewBox: "0 0 70 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.546 25.2699C36.6435 25.4219 36.8153 25.5095 36.9956 25.4992C37.1759 25.4888 37.3365 25.3821 37.416 25.2199C39.4506 21.0661 43.4747 15.3391 48.9086 11.6574C54.3177 7.99258 61.1002 6.3622 68.7717 10.3001C68.9673 10.4005 69.2055 10.3613 69.3587 10.2036C69.5119 10.0458 69.544 9.80651 69.4379 9.61393C67.3373 5.80196 63.1504 1.35773 57.4034 0.609124C51.7141 -0.13198 44.7198 2.77231 36.96 12.9602C33.2345 8.27265 27.1603 2.92931 20.5506 1.69322C17.0994 1.0478 13.506 1.52429 10.0597 3.78783C6.62559 6.04336 3.37725 10.0467 0.543575 16.3821C0.443421 16.606 0.520496 16.8695 0.725531 17.0042C0.930567 17.1388 1.203 17.1049 1.3687 16.924C4.30076 13.7231 9.56758 10.3118 15.8273 10.4253C22.0535 10.5382 29.4115 14.1433 36.546 25.2699Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird9);
export default __webpack_public_path__ + "static/media/bird 9.82176bf100aa9c2c2f22c56be3aab17c.svg";
export { ForwardRef as ReactComponent };